import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from '../authentication.service';
import { environment } from '../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private apiUrl: string;
    private faqsUrl: string;

    constructor(private injector: Injector) {
        this.apiUrl =  environment.api.protocol + environment.api.hostname + environment.api.path;
        this.faqsUrl =  environment.wordpress.protocol + environment.wordpress.hostname + environment.wordpress.path;
    }

    /*
     * Add authorization header to all requests except the request that looks up for subscriptions of anonymous user, all CMS requests (wordpress REST API), and the request that looks up if there is an active promotion (to show promotion message in home page)
    */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const auth = this.injector.get(AuthenticationService);
        const token = auth['token'];
        if (token && request.url !== this.apiUrl + 'FindSubscription' && request.url !== this.apiUrl + 'ContactFormSubmit' && !request.url.match(this.faqsUrl) && request.url !== this.apiUrl + 'CreditPromotion') {
            request = request.clone({
                headers: request.headers.set('Authorization', token).set('Cache-Control', 'no-cache, no-store')
            });
        }
        return next.handle(request);
    }
}




// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/token-interceptor.service.ts